export interface IUserSession {
    access_token?: string;
    refresh_token?: string;
    expires_in?: number;
    token_type?: string;
    user?: IUser;
    company?: ICompany;
}

export interface ICompany {
    id?: string;
    name?: string;
    contact_first_name?: string;
    contact_last_name?: string;
    contact_email?: string;
    contact_mobile_number?: string;
    account_id?: string;
    is_verified?: boolean;
    verified_at?: any;
    is_active?: boolean;
}

export interface IUser {
    id?: string;
    email?: string;
    first_name?: string;
    last_name?: string;
    username?: string;
    gender?: string;
    profile_photo?: string;
    country?: string;
    state?: string;
    city?: string;
    address_line_1?: string;
    address_line_2?: string;
    pincode?: string;
    phone_number?: string;
    is_active?: boolean;
    is_verified?: boolean;
    created_at?: string;
    updated_at?: string;
    date_of_birth?: string;
    verified_at?: string | null;
}

export class UserSession {
    constructor(
        public access_token?: string,
        public refresh_token?: string,
        public expires_in?: number,
        public token_type?: string,
        public user?: User,
        public company?: Company,
    ) { }
    get token(): string {
        return this.access_token || '';
    }
}

export class Company {
    constructor(
        public id?: string,
        public name?: string,
        public contact_first_name?: string,
        public contact_last_name?: string,
        public contact_email?: string,
        public contact_mobile_number?: string,
        public account_id?: string,
        public is_verified?: boolean,
        public verified_at?: any,
        public is_active?: boolean,
    ) { }
}
export class User {
    constructor(
        public id?: string,
        public email?: string,
        public first_name?: string,
        public last_name?: string,
        public username?: string,
        public gender?: string,
        public profile_photo?: string,
        public country?: string,
        public state?: string,
        public city?: string,
        public address_line_1?: string,
        public address_line_2?: string,
        public pincode?: string,
        public phone_number?: string,
        public is_active?: boolean,
        public is_verified?: boolean,
        public created_at?: string,
        public updated_at?: string,
        public date_of_birth?: string,
        public verified_at?: string | null,

    ) { }
    getName(): string {
        return `${this.first_name || ''} ${this.last_name || ''}`.trim() || 'Unknown User';
    }
}
